// src/pages/AppliAdmin/ContactForm/components/ContactAdminHeader.jsx
import React from "react";
import {
  FaEnvelopeOpenText,
  FaInbox,
  FaCalendarDay,
  FaClock,
  FaSync,
} from "react-icons/fa";
import { formatDateTimeFR, formatRelativeDate } from "../contactFormUtils";

export default function ContactAdminHeader({
  stats,
  unreadCount,
  loading,
  onRefresh,
}) {
  const lastDate = stats?.lastMessage?.created_at;

  return (
    <section className="overflow-hidden rounded-[32px] bg-slate-950 shadow-xl dark:bg-slate-900">
      <div className="relative p-5 sm:p-7 lg:p-8">
        <div className="absolute -right-16 -top-16 h-52 w-52 rounded-full bg-indigo-500/25 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-40 w-40 rounded-full bg-fuchsia-500/20 blur-3xl" />
        <div className="absolute -bottom-20 -left-20 h-56 w-56 rounded-full bg-blue-500/20 blur-3xl" />

        <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div>
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-xs font-bold uppercase tracking-[0.18em] text-white/80">
              <FaEnvelopeOpenText />
              Administrateur
            </div>

            <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Messages ContactForm
            </h1>

            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-300 sm:text-base">
              Consultez les demandes envoyées depuis le formulaire de contact,
              filtrez les messages importants et traitez rapidement les non lus.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-950 shadow-lg transition hover:-translate-y-0.5 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaSync className={loading ? "animate-spin" : ""} />
            Actualiser
          </button>
        </div>

        <div className="relative mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
          <HeaderStat
            icon={FaInbox}
            label="Messages"
            value={stats.total}
            helper={`${stats.filtered} affiché${stats.filtered > 1 ? "s" : ""}`}
          />

          <HeaderStat
            icon={FaEnvelopeOpenText}
            label="Non lus"
            value={unreadCount}
            helper="à traiter"
          />

          <HeaderStat
            icon={FaCalendarDay}
            label="Aujourd’hui"
            value={stats.today}
            helper="nouveaux messages"
          />

          <HeaderStat
            icon={FaClock}
            label="Dernier message"
            value={lastDate ? formatRelativeDate(lastDate) : "—"}
            helper={lastDate ? formatDateTimeFR(lastDate) : "aucun message"}
          />
        </div>
      </div>
    </section>
  );
}

function HeaderStat({ icon: Icon, label, value, helper }) {
  return (
    <div className="rounded-[24px] border border-white/10 bg-white/[0.08] p-4 text-white shadow-sm backdrop-blur">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white/10 text-white">
          <Icon />
        </div>

        <div className="min-w-0">
          <div className="text-xs font-bold uppercase tracking-wide text-white/60">
            {label}
          </div>
          <div className="mt-0.5 truncate text-2xl font-bold">{value}</div>
          <div className="mt-0.5 truncate text-xs text-white/55">{helper}</div>
        </div>
      </div>
    </div>
  );
}